export default async function delete_project(id: ID, callback?: callback) {
    const project = gd.session.projects.get(id)!

    if (project.isTag) {
        gd.modals.confirm.deleteByNameWithComment('Tag', project.name, 'All tag references will be deleted as well.', async ()=>{
            const parentId          = project.parentId
            const currentProjectId  = (gd.getApp() as any).projectId
            const childrenProjects  = gd.tree.findProjectChildren(id).map((p:any)=>p.id).concat([id])

            //check if current project is deleted or current project is one of children of deleted project
            if (id === currentProjectId || childrenProjects.includes(currentProjectId)) {
                //then we need to redirect to it's parent if able or to my work
                if (parentId) gd.goTo('p/'+parentId)
                else gd.goTo('')
            }

            await gd.api.Project.delete(project.id).promise()
            gd.growl.successSticky("Tag "+project.name+" has been deleted.")
            gd.modal.hide()
        })
    } else {
        gd.modals.project.deleteProject(null,project.id, callback)
    }
}